import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { formatISO } from "date-fns";
import {
  Asset_Status,
  CalculationBalance,
  Risk_Level1,
  SelectedAccount,
  SelectedAsset,
  UserDetails,
  addAssetItem,
  getRiskLevel1,
  getRiskLevel2,
  getRiskLevel3,
  selectAsset,
  setCl_value,

} from "../../redux/userSlice";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AccountAssets = () => {
  
  const navigate = useNavigate();
  const  CalculationResponse = useSelector(CalculationBalance);
  const APi_Url = process.env.REACT_APP_ENIGMA_API;
  const dispatch = useDispatch();
  const userDetails = useSelector(UserDetails);
  const selectedAccountDetails = useSelector(SelectedAccount);

const AssetStatus=useSelector(Asset_Status)

  const selectedAssetDetails = useSelector(SelectedAsset);

const [clBalance,setClBalance]=useState([]);


  const [assets, setAssets] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const token = userDetails?.token;

  

  const navigationPage=()=>{
    const selected_account = selectedAccountDetails.accountName;
   
    navigate(`/${selected_account}-cl`);
  }
    const handleModal = () => {
      // if (!selectedAccountDetails) {
      //   toast.error("Please create an account");
      //   return; // Prevent further execution if account details are not available
      // }
    
      // // Extract account name after confirming selectedAccountDetails is not null
     
    
      // // Check AssetStatus and navigate or show the modal accordingly
      // if (AssetStatus) {
       
      //   toast.error("You have already submitted the value", {
      //     onClose: navigationPage, // Call navigationPage when the toast is closed
      //   });
      // } else {
        
      // }

      setShowModal(true);
    };
  
  
  useEffect(() => {
    showAssets();
  }, []);

  useEffect(()=>{
    get_RiskLeve1();
    get_RiskLeve2();
    get_RiskLeve3();
  },[])

  const showAssets = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/AssetList/get-all-Asset-List`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("Response:", response.data.response);
      setAssets(response.data.response);
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  // const today = new Date();
  // const createdDate = formatISO(today);

  // modal open function
  const handleCLick = (id) => {
    // if (id === 1) {
    //   handleModal();
    // }
    handleModal();
  };

  // Risklevel 1 calculation
 
  const get_RiskLeve1 = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-1/${userDetails.id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("rewsponse cl balnce",response.status)
      if(response.status==200){
      setClBalance(response?.data?.response[0]);
     

      }
     
      // if(response==''){
      //   setClBalance
      // }
      // dispatch(getRiskLevel1(response.data.response));
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };
  // Risk level 2
  const get_RiskLeve2 = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-2/${userDetails.id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      
      // if(response==''){
      //   dispatch(addAssetItem(false));
      // }
      // dispatch(getRiskLevel2(response.data.response));

      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };
  // Risk Level 3
  const get_RiskLeve3 = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-3/${userDetails.id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      
      // if(response.data.response==''){
      //   dispatch(addAssetItem(false));
      // }
      // else{
      //   dispatch(addAssetItem(true));
      // }
    
      // dispatch(getRiskLevel3(response.data.response));
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };



  // modal validation from submit start

  const initialValues = {
    pointValue: clBalance?clBalance.pointValue:"",
    tickSize: clBalance?clBalance.tickSize:"",
    rtComms: clBalance?clBalance.rtComms:"",
    trailStop1: clBalance?clBalance.trailStop1:"",
    trailStop2: clBalance?clBalance.trailStop2:"",
    be: clBalance?clBalance.be:"",
    tP1: clBalance?clBalance.tP1:"",
    tP2: clBalance?clBalance.tP2:"",
    tP3: clBalance?clBalance.tP3:"",
    tP4: clBalance?clBalance.tP4:"",
  };

  const validationSchema = Yup.object({
    pointValue: Yup.string()
      .min(3, "pointValue must be at least 3 characters")
      .required("pointValue is Required"),
    tickSize: Yup.string()
      .min(1, "tickSize must be at least 3 characters")
      .required("tickSize is Required"),
    rtComms: Yup.string()
      .min(1, "rtComms must be at least 3 characters")
      .required("rtComms is Required"),
    trailStop1: Yup.string()
      .min(1, "trailStop1 must be at least 3 characters")
      .required("trailStop1 is Required"),
    trailStop2: Yup.string()
      .min(1, "trailStop2 must be at least 3 characters")
      .required("trailStop2 is Required"),
    be: Yup.string()
      .min(1, "be must be at least 3 characters")
      .required("be is Required"),
    tP1: Yup.string()
      .min(1, "tP1 must be at least 3 characters")
      .required("tP1 is Required"),
    tP2: Yup.string()
      .min(1, "tP2 must be at least 3 characters")
      .required("tP2 is Required"),
    tP3: Yup.string()
      .min(1, "tP3 must be at least 3 characters")
      .required("tP3 is Required"),
    tP4: Yup.string()
      .min(1, "tP4 must be at least 3 characters")
      .required("tP4 is Required"),
  });
  // console.log("selectedAccountDetails.accountName",selectedAccountDetails.accountId)

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    setShowModal(false);
    const selected_account = selectedAccountDetails.accountName
    const data = { ...values, userId: userDetails.id ,riskLevel1:CalculationResponse?parseFloat(CalculationResponse?.aggressiveDRPT):"",
      riskLevel2:CalculationResponse?parseFloat(CalculationResponse?.neutralDRPT):"",
      riskLevel3:CalculationResponse?parseFloat(CalculationResponse?.conservativeDRPT):"" };
    // dispatch(setCl_value(values));
    // const newItem = {Account: selectedAccountDetails.accountName, Asset: selectedAssetDetails.assetName, status: true};
  
    const stringData = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        stringData[key] = data[key].toString();
      }
    }

    const from_Data = JSON.stringify(stringData);
    // console.log("from_Data",from_Data);
    // navigate(`/${selected_account}-cl`);
    try {
      const response = await axios.post(
        `${APi_Url}api/RiskLevelCalculation/Risk-Level1-Calculation`,
        from_Data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("RESPONSE calculation ems",response)
      toast.success("Successfully calculated");
      // get_RiskLeve1();
      // get_RiskLeve2();
      // get_RiskLeve3();
      // dispatch(addAssetItem(true));
      // navigate(`/${selected_account}-cl`);
      navigate('/account2')
      // /test-cl
      // navigate('/test-cl');
    } catch (error) {
      console.error("Error ", error);
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
  };
  // modal validation from submit end
  return (
    <div className="dropdown">
      <button
        className="btn dropdown-toggle form-select"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {selectedAssetDetails
                    ? selectedAssetDetails.assetName
                    : "Select Asset"}
        
      </button>
      <ul className="dropdown-menu">
        {assets.map((asset) => (
          <li key={asset.assetId}>
            <Link
              className="dropdown-item"
              onClick={() => {handleCLick(asset.assetId); dispatch(
                selectAsset({
                  asset: {
                    assetId: asset.assetId,
                    assetName: asset.assetName,
                  },
                })
              )}}
            >
              {asset.assetName}
            </Link>
          </li>
        ))}
      </ul>
      {/* for account modal */}

      <div
        className={`modal fade inputmodal ${showModal ? "show" : ""}`}
        aria-hidden="true"
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        id="asset-modal"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1>MoneyManagement</h1>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
              >
                {({ isSubmitting, isValid, dirty }) => (
                  <Form className="row needs-validation">
                    <div className="col-12">
                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">
                              Point value
                            </label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="pointValue"
                                name="pointValue"
                                placeholder="Input here"
                                className="form-control"
                                onWheel={(e) => e.target.blur()}
                              />
                              <ErrorMessage
                                name="pointValue"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row">
                            <label className="col-4 col-form-label">
                              Tick size
                            </label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="tickSize"
                                name="tickSize"
                                placeholder="Input here"
                                className="form-control"
                                onWheel={(e) => e.target.blur()}
                              />
                              <ErrorMessage
                                name="tickSize"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">
                              Rt Comms
                            </label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="rtComms"
                                name="rtComms"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="rtComms"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="row ">
                            <label className="col-4 col-form-label">
                              Trail Stop 1
                            </label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="trailStop1"
                                name="trailStop1"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="trailStop1"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">
                              Trail Stop 2
                            </label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="trailStop2"
                                name="trailStop2"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="trailStop2"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="row">
                            <label className="col-sm-4 col-form-label">
                              Be
                            </label>
                            <div className="col-sm-8">
                              <Field
                                type="number"
                                id="be"
                                name="be"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="be"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">Tp 1</label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="tP1"
                                name="tP1"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="tP1"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">Tp 2</label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="tP2"
                                name="tP2"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="tP2"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">Tp 3</label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="tP3"
                                name="tP3"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="tP3"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-6">
                          <div className="row">
                            <label className="col-4 col-form-label">Tp 4</label>
                            <div className="col-8">
                              <Field
                                type="number"
                                id="tP4"
                                name="tP4"
                                placeholder="Input here"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="tP4"
                                component="div"
                                className="error_msg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isValid}
                    <div className="col-12">
                      <button
                        className="btn kevlar_btn"
                        type="submit"
                        data-bs-dismiss={isValid ? "modal" : undefined}
                      >
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>

              <div className="row mb-3">
                <div className="col-12">
                  <button
                    className="btn kevlar_btn"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountAssets;
